import { getJSON } from 'bv-fetch';

export default () => (
  getJSON('/seo_data/enabled_locales').catch(() => ({}))
);
